import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TabsComponent } from './tabs/tabs.component';
import { WorkflowComponent } from './workflow/workflow.component';
import { WorkflowsComponent } from './workflows.component';



const routes: Routes = [
  {path :"",component:WorkflowsComponent ,children:[
  {path:"workflow",component:WorkflowComponent},
   {path:"tabs/:id/:vid",component:TabsComponent},
   {path:"", redirectTo: 'workflow', pathMatch: 'full'}
  ]}
  
 ];
@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})
export class WorkflowsRoutingModule { }
